export class ARPaymentParameterDto {
    communityId: number;
    managementCompanyId: number;
    paymentId: number;
    clearCache: boolean;

    // Transient field used to access vendor code for cirabook vendor hyperlink
    vendorCode: string;

    getQueryString(): string {
        const tokens = [];
        tokens.push(`managementCompanyId=${this.managementCompanyId}`);
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (!!this.paymentId) {
            tokens.push(`paymentId=${this.paymentId}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
